<template>
    <div class="channelItem superItem" :class="{'superItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallPossion.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url)">查看详情分析 ></em>
                <span v-else-if="data.info.tag">{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.info.url)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataSuperDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataSuper.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <img src="../../../assets/img/datamodel/match/hit.png" alt="">
                            <p>交易量
                                <span class="org" v-if="data.schedule.trade_text === '较小'">{{ data.schedule.trade_text }}</span>
                                <span class="blue" v-if="data.schedule.trade_text === '适中'">{{ data.schedule.trade_text }}</span>
                                <span class="red" v-if="data.schedule.trade_text === '较大'">{{ data.schedule.trade_text }}</span>
                                <span class="purple" v-if="data.schedule.trade_text === '非常大'">{{ data.schedule.trade_text }}</span>
                            </p>
                            <p>偏差值
                                <span class="org" v-if="data.schedule.deviation_text === '较小'">{{ data.schedule.deviation_text }}</span>
                                <span class="blue" v-if="data.schedule.deviation_text === '适中'">{{ data.schedule.deviation_text }}</span>
                                <span class="red" v-if="data.schedule.deviation_text === '较大'">{{ data.schedule.deviation_text }}</span>
                                <span class="purple" v-if="data.schedule.deviation_text === '非常大'">{{ data.schedule.deviation_text }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="haveData" v-if="data.is_buy == 1 && data.has_data == 1">
                <div class="superCon">
                    <p class="name">必发提点</p>
                    <div class="sBox">
                        <div class="sItem">
                            <p>交易量</p>
                            <span class="org" v-if="data.analy.trade_text === '较小'">{{ data.analy.trade_text }}</span>
                            <span class="blue" v-if="data.analy.trade_text === '适中'">{{ data.analy.trade_text }}</span>
                            <span class="red" v-if="data.analy.trade_text === '较大'">{{ data.analy.trade_text }}</span>
                            <span class="purple" v-if="data.analy.trade_text === '非常大'">{{ data.analy.trade_text }}</span>
                        </div>
                        <div class="sItem">
                            <p>偏差值</p>
                            <span class="org" v-if="data.analy.deviation_text === '较小'">{{ data.analy.deviation_text }}</span>
                            <span class="blue" v-if="data.analy.deviation_text === '适中'">{{ data.analy.deviation_text }}</span>
                            <span class="red" v-if="data.analy.deviation_text === '较大'">{{ data.analy.deviation_text }}</span>
                            <span class="purple" v-if="data.analy.deviation_text === '非常大'">{{ data.analy.deviation_text }}</span>
                        </div>
                    </div>
                </div>
                <div class="superCon">
                    <p class="name">本场推荐</p>
                    <div class="sBox">
                        <div class="sItem">
                            <p>首选</p>
                            <span class="red" v-if="data.analy.predict_result == 1">主胜</span>
                            <span class="green" v-if="data.analy.predict_result == 2">客胜</span>
                            <span class="blue" v-if="data.analy.predict_result == 3">平局</span>
                        </div>
                        <div v-if="data.analy.second_predict_result" class="sItem">
                            <p>次选</p>
                            <span class="red" v-if="data.analy.second_predict_result == 1">主胜</span>
                            <span class="green" v-if="data.analy.second_predict_result == 2">客胜</span>
                            <span class="blue" v-if="data.analy.second_predict_result == 3">平局</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isLogin, doLogin, isJHAppios, isJHApp } from "../../../utils/base";
export default {
    name: 'superItem',
    props: ['data', 'isDark'],
    methods: {
        gobuy () {
            if (!isLogin) {
                doLogin();
                return
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            }
            this.$emit('gobuy', url)
        },
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        }
    }
}
</script>

<style lang="less" scoped>
.superItem{
    .noData{
        .predict{
            position: relative;
            img{
                position: absolute;
                display: block;
                width: 50px;
                left: -40px;
                top: 0;
            }
            p{
                display: flex;
                justify-content: flex-end;
                font-size: 12px;
                color: #333;
                margin-top: 5px;
                span{
                    display: line-block;
                    width: 35px;
                    height: 16px;
                    border-radius: 2px;
                    line-height: 16px;
                    color: #fff;
                    margin-left: 5px;
                    text-align: center;
                }
                .red {
                    background: #EB4A46;
                }
                .org {
                    background: #FF7247;
                }
                .blue {
                    background: #4B86EE;
                }
                .green {
                    background: #43A000;
                }
                .purple {
                    background: #7B00D1;
                }
            }
        }
    }
    .haveData{
        padding: 0 10px !important;
    }
    .superCon{
        height: 40px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:last-child{
            border: none;
        }
        .name{
            width: 30%;
            font-size: 12px;
            color: #333333;
            line-height: 17px;
        }
        .sBox{
            width: 70%;
            display: flex;
            justify-content: space-between;
            .sItem{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 50%;
                p{
                    font-size: 12px;
                    color: #333333;
                    line-height: 17px;
                }
                span{
                    display: block;
                    width: 40px;
                    height: 16px;
                    line-height: 16px;
                    font-size: 12px;
                    color: #ffffff;
                    border-radius: 2px;
                    font-weight: bold;
                    text-align: center;
                    margin-left: 5px;
                }
                .red {
                    background: #EB4A46;
                }
                .org {
                    background: #FF7247;
                }
                .blue {
                    background: #4B86EE;
                }
                .green {
                    background: #43A000;
                }
                .purple {
                    background: #7B00D1;
                }
            }
        }
    }
}
.superItemDark{
    .noData .predict{
        p{
            color: #d3d3d3;
        }
    }
    .haveData{
        background-color: #232323 !important;
    }
    .superCon{
        border-color: #2f2f2f;
        .name{
            color: #d3d3d3;
        }
        .sBox{
            .sItem{
                p{
                    color: #d3d3d3;
                }
            }
        }
    }
}
</style>
